import { createSelector } from '@ngrx/store';
import { dietaryTagsImagesState } from '../root';

export const getDietaryTagImages = createSelector(dietaryTagsImagesState, (dietaryTagsImages) => dietaryTagsImages);
